import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Modules
import { SharedModule }      from 'src/app/shared/shared.module';
import { WebTemplateModule } from 'src/app/web-template/web-template.module';

// Components
import { CourseSummaryCardComponent }     from './components/course-summary-card/course-summary-card.component';

// Elements
import { DiscountsSummaryTableComponent } from './elements/discounts-summary-table/discounts-summary-table.component';
import { CoursesSummaryTableComponent   } from './elements/courses-summary-table/courses-summary-table.component';

// Pages
import { AllCoursesComponent }      from './pages/all-courses/all-courses.component';
import { CourseDetailComponent }    from './pages/course-detail/course-detail.component';
import { FaqComponent }             from './pages/faq/faq.component';
import { SchedulesPricesComponent } from './pages/schedules-prices/schedules-prices.component';


@NgModule({

    declarations: [

        CourseSummaryCardComponent,
        
        DiscountsSummaryTableComponent,
        CoursesSummaryTableComponent,

        AllCoursesComponent,
        CourseDetailComponent,
        FaqComponent,
        SchedulesPricesComponent
        
    ],

    imports: [
        CommonModule,
        SharedModule,
        WebTemplateModule
    ],

    exports: [
        AllCoursesComponent,
        CourseDetailComponent,
        FaqComponent,
        SchedulesPricesComponent
    ]

})

export class EditionModule { }
